import { createContext, useContext, useState, Dispatch, SetStateAction, ReactNode, useEffect } from 'react';
import { getStoreStorage, setStoreStorage } from '../container/store/utils/StoreStorage';
import { AssesmentInterface } from '../container/store/details/assessment/interface/AssesmentInterface'
import { http } from '../services/apiSecurity/Http.interceptor'
import { IFlag } from '../container/store/utils/Flags';

interface useContextInterface {
  flag: String;
  setFlag: Dispatch<SetStateAction<String>>;
  nameStore: String;
  store: String;
  setStore(value: String, name: String, index: number, flag:String): void;
  index?: number;
  selectedStore: any
  setSelectedStore:any,
  assesmentList: AssesmentInterface[],
  setAssesmentList: any,
  arrayFlags: IFlag[],
  getFlags: any
}


interface StoreComponent {
  children: ReactNode;
}
const StoreContext = createContext<useContextInterface>({} as useContextInterface);

export default function StoreProvider({ children }: StoreComponent) {

  const [arrayFlags, setArrayFlags] = useState<IFlag[]>([])
  const [flag, setFlag] = useState<String>(getStoreStorage().flag);
  const [nameStore, setNameStore] = useState<String>(getStoreStorage().nameStore);
  const [store, setStoreParams] = useState<String>(getStoreStorage().store || '');
  const [index, setIndex] = useState<number | undefined>(getStoreStorage().index);
  const [selectedStore, setSelectedStore] = useState({});
  const [assesmentList, setAssesmentList] = useState([]);

  const setStore = (value: String, nameStore: String, index: number, flag:String) => {
    setStoreParams(value);
    setNameStore(nameStore);
    setIndex(index);
    setStoreStorage({ flag, store: value, index, nameStore });
  }

  const getFlags = () => {
    http.get('/listAllFlags').then(r => {
        if(r.data.length){
          let flagList:IFlag[] = []
          r.data.map((d:IFlag) => {
            flagList.push({
              id: String(d.id),
              flag: d.flag
            })
          })
          setArrayFlags(flagList)
        }
    }).catch(() => {
      setArrayFlags([])
    })
  }

  const updateStoreState = () => {
    if(store && Object.getOwnPropertyNames(selectedStore).length === 0){
      http.get(`/stores/${store}`).then(r => {
        setSelectedStore(r.data)
      }).catch(() => {
        setSelectedStore({})
      })
    }
  }

  useEffect(() => {
    getFlags()
    updateStoreState()
  },[])

  return (
    <StoreContext.Provider value={{ flag, setFlag, store, setStore, index, nameStore, selectedStore, setSelectedStore, assesmentList, setAssesmentList, arrayFlags, getFlags }}> {children} </StoreContext.Provider>
  )
}

export function useStore() {
  const context = useContext<useContextInterface>(StoreContext);
  if (!context) throw new Error("Error must be used within a StoreProvider")
  const { flag, setFlag, store, setStore, index, nameStore, selectedStore, setSelectedStore, setAssesmentList, assesmentList, arrayFlags, getFlags } = context;
  return { flag, setFlag, store, setStore, index, nameStore, selectedStore, setSelectedStore, setAssesmentList, assesmentList, arrayFlags, getFlags };
}
